import { Input } from 'antd'
import React,{useState, useCallback} from 'react';
import { SearchOutlined } from '@ant-design/icons';

function debounce(func, delay) {
  let timerId;
  return function (...args) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
          func.apply(this, args);
      }, delay);
  };
}

export default function TabSearch({size, val, onChangeFunc,width}) {
  const [searchQuery, setSearchQuery] = useState(val);
    const containerStyles={
        borderColor: '#E0E2E6',
        boxShadow: '0px 1px 2px 0px #1018280D',
        color:'#5C667B !important',
        zIndex:'0',
        width:width
    }
    const debouncedFetch = useCallback(debounce((value)=>onChangeFunc(value), 1000), [onChangeFunc]);
    const handleInputChange = (e) => {
      setSearchQuery('')
      const value = e.target.value;
      setSearchQuery(value); // Update UI immediately
      debouncedFetch(e); // Delay the API call
  };
  return (
    <>
    <Input style={containerStyles} value={searchQuery} onChange={(e)=>handleInputChange(e)} prefix={<SearchOutlined style={{color:'#ACB6C6'}} />} allowClear placeholder='Search' size={size} />
    </>
  )
}
